import { connect } from 'react-redux';
import isNil from 'lodash/isNil';
import View from './ProgressChartView';
import MobileView from '../../../../MobileFinancialPlan/MobileInsurance/MobileLongTermCare/MobileProgressChart/MobileProgressChartView';
import { chartDataSelector, goalDataSelector } from './ProgressChartSelector';

const mapStateToProps = (state, ownProps) => {
  const chartData = chartDataSelector(state, ownProps),
    goalData = goalDataSelector(state, ownProps),
    ownerIndex = !isNil(ownProps.ownerIndex) ? ownProps.ownerIndex : goalData.ownerIndex,
    breakdown =
      ownerIndex === 0
        ? ownProps.subgoalData.BreakdownPrincipal
        : ownProps.subgoalData.BreakdownSpouse;

  return {
    annualInsuranceCost: breakdown.AnnualInsuranceCost,
    annualLTCCost: breakdown.AnnualLTCCost,
    assetsToLiquidate: breakdown.AssetsToLiquidate,
    dailyBenefit: breakdown.DailyBenefit,
    ownerIndex,
    chartData,
    hasChartData: !!chartData,
  };
};

export default connect(mapStateToProps)(View);
export const MobileProgressChart = connect(mapStateToProps)(MobileView);
